import { tv } from 'tailwind-variants';

const labelTagStyles = tv({
  slots: {
    container: `
      iris:pointer-events-none
      iris:inline-flex
      iris:items-center
      iris:rounded-(--comp-size-radius-label-tag)
      iris:px-(--comp-space-padding-label-tag-horizontal)
      iris:py-(--comp-space-padding-label-tag-vertical)
      iris:font-(family-name:--comp-type-font-label-tag)
      iris:text-(length:--comp-type-size-label-tag)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-label-tag)!
      iris:tracking-(--comp-type-tracking-label-tag)
      iris:[text-transform:var(--comp-type-transform-label-tag)]
      iris:select-none
    `,
    iconWrapper: `
      iris:mr-(--comp-space-gap-label-tag-icon)
      iris:flex
      iris:size-(--comp-size-icon-label-tag)
      iris:items-center
      iris:justify-center
    `
  },
  variants: {
    variant: {
      neutral: {
        container: `
          iris:bg-(--comp-color-background-label-tag-neutral)
          iris:text-(--comp-color-content-label-tag-neutral)
        `
      },
      positive: {
        container: `
          iris:bg-(--comp-color-background-label-tag-positive)
          iris:text-(--comp-color-content-label-tag-positive)
        `
      },
      negative: {
        container: `
          iris:bg-(--comp-color-background-label-tag-negative)
          iris:text-(--comp-color-content-label-tag-negative)
        `
      },
      brand: {
        container: `
          iris:bg-(--comp-color-background-label-tag-brand)
          iris:text-(--comp-color-content-label-tag-brand)
        `
      },
      accent: {
        container: `
          iris:bg-(--comp-color-background-label-tag-accent)
          iris:text-(--comp-color-content-label-tag-accent)
        `
      }
    },
    inverse: {
      false: {},
      true: {}
    }
  },
  compoundVariants: [{
    variant: "neutral",
    inverse: true,
    class: {
      container: `
          iris:bg-(--comp-color-background-label-tag-neutral-inverse)
          iris:text-(--comp-color-content-label-tag-neutral-inverse)
        `
    }
  }, {
    variant: "positive",
    inverse: true,
    class: {
      container: `
          iris:bg-(--comp-color-background-label-tag-positive-inverse)
          iris:text-(--comp-color-content-label-tag-positive-inverse)
        `
    }
  }, {
    variant: "negative",
    inverse: true,
    class: {
      container: `
          iris:bg-(--comp-color-background-label-tag-negative-inverse)
          iris:text-(--comp-color-content-label-tag-negative-inverse)
        `
    }
  }, {
    variant: "brand",
    inverse: true,
    class: {
      container: `
          iris:bg-(--comp-color-background-label-tag-brand-inverse)
          iris:text-(--comp-color-content-label-tag-brand-inverse)
        `
    }
  }, {
    variant: "accent",
    inverse: true,
    class: {
      container: `
          iris:bg-(--comp-color-background-label-tag-accent-inverse)
          iris:text-(--comp-color-content-label-tag-accent-inverse)
        `
    }
  }],
  defaultVariants: {
    variant: "neutral"
  }
});

export { labelTagStyles as default };
